import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { IndexButton } from '../../../app/interfaces/base/IndexButton';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import isFunction from 'lodash-es/isFunction';
import { Router } from '@angular/router';

@Component({
  selector: 'fury-page-header-buttons',
  templateUrl: './page-header-buttons.component.html',
  styleUrls: ['./page-header-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PageHeaderButtonsComponent implements OnInit, OnDestroy {

  @Input() buttons: IndexButton[] = [];

  public mobileView: boolean = false;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private breakpointService: BreakpointObserver,
              private router: Router) {
  }

  ngOnInit(): void {
    this.breakpointService.observe([Breakpoints.TabletLandscape, Breakpoints.WebLandscape])
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: BreakpointState) => this.mobileView = !value.matches);
  }

  handleClick(functionOrRoute: Function | string): void {
    if (isFunction(functionOrRoute)) {
      functionOrRoute();
    } else {
      this.router.navigateByUrl(<string>functionOrRoute).then((): void => {});
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
